module.exports = __webpack_public_path__ + "static/modal-btn.ebad9a5d.png";